import { thresholdsToHighchartsZones } from "../thresholds";
const thresholdsTransformer = (series) => {
    return series.map((mappedSeries) => {
        if (mappedSeries.thresholds) {
            return Object.assign({}, mappedSeries, {
                zones: thresholdsToHighchartsZones(mappedSeries.thresholds),
            });
        }
        return mappedSeries;
    });
};
export default thresholdsTransformer;
